
import React, { useState, useRef } from "react";
import { FaBars } from 'react-icons/fa';
import NavLink from "./navlink";

const Hamburger = ({ links }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  const handleOptionClick = () => {
    setIsOpen(false);
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="relative inline-block text-left">
        <div>
          <button
            type="button"
            className="flex items-center justify-center p-2 rounded bg-gray-200 dark:bg-gray-800 text-black dark:text-white"
            id="menu-button"
            onClick={toggleDropdown}
            ref={buttonRef}
          >
            <FaBars className="text-black dark:text-white" size={18} />
          </button>
        </div>

        {isOpen &&
          <div
            className="absolute z-10 mt-2 min-w-36 right-0 rounded-md bg-white text-black dark:text-white dark:bg-gray-600 focus:outline-none"
            style={{ transformOrigin: 'top right' }}
            role="menu"
            tabindex="-1"
            ref={dropdownRef}
          >
            <div className="flex flex-col gap-2 p-4" role="none">
              {links.map((item) => (
                <NavLink target={item.target} key={item.title}>
                  <button className="border-none" onClick={handleOptionClick}>{item.title}</button>
                </NavLink>
              ))}
            </div>
          </div>}
      </div>
    </>
  );
};

export default Hamburger;